export const RESOURCE_ALL_SET = "RESOURCE_ALL_SET";
export const RESOURCE_RESET = "RESOURCE_RESET";
export const RESOURCE_SET = "RESOURCE_SET";
